import API from "../plugin/libs/axios";
import URL from '../plugin/config/url'
import addRouter from '@wd/cms-pc/addRouter'
import message from '@wd/cms-pc/message'
const pako = require('pako');
function IsMobile(){
  let userAgent = navigator.userAgent,Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
  console.log('userAgent:',userAgent)
  return Agents.some((i)=>{
      return userAgent.includes(i)
  })
}
function addErrorRouter(router) {
  let errorPage = [
    {
      path: '/401',
      name: 'error_401',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/401.vue'),
    },
    {
      path: '/500',
      name: 'error_500',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/500.vue'),
    },
    {
      path: '*',
      name: 'error_404',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/404.vue')
    },
  ]
  router.addRoutes(errorPage)
}


function Utf8ArrayToStr(array) {
  var out, i, len, c;
  var char2, char3;
  out = "";
  len = array.length;
  i = 0;
  while (i < len) {
    c = array[i++];
    switch (c >> 4) {
      case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12: case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(((c & 0x0F) << 12) |
          ((char2 & 0x3F) << 6) |
          ((char3 & 0x3F) << 0));
        break;
    }
  }
  console.log(JSON.parse(out));
  return JSON.parse(out)
}

function unzip(b64Data) {
  var strData = b64Data;
  var charData = strData.split('').map(function (x) { return x.charCodeAt(0); });
  var binData = new Uint8Array(charData);
  var data = pako.ungzip(binData);
  return Utf8ArrayToStr(data);
}
//网站换肤功能的使用
// import 'mutationobserver-shim'
// import theme from "./theme/index";
// import cssVars from "css-vars-ponyfill";
// function setTheme(name ='init'){
//   const initTheme = (name) => {
//     document.documentElement.setAttribute("data-theme", name);
//     cssVars({
//       rootElement:document.getElementById('appContainer'),
//       silent:true,
//       watch: true, // 当添加，删除或修改其<link>或<style>元素的禁用或href属性时，ponyfill将自行调用
//       variables: theme[name], // variables 自定义属性名/值对的集合
//       onlyLegacy: false, // false  默认将css变量编译为浏览器识别的css样式  true 当浏览器不支持css变量的时候将css变量编译为识别的css
//     });
//   }
//    initTheme(name);
// }




function getLayoutSetting(router, _this) {
  // const institutionDomain = localStorage.getItem('institutionDomain');
  let confUrl;
  let _url;
  let base = require('js-base64').Base64;
  const port = window.location.port;
  const hostname = window.location.hostname;
  const UrlName = '/modular/admin/v1';
  // let frontendConfig;
  // if(institutionDomain) {
  //   confUrl = base.encode(institutionDomain);
  //   console.log('confUrl---->',confUrl)
  // } else {
    confUrl = port ? base.encode(URL.TestDomain) : base.encode(hostname);
  // }
  // if(isB === 'isB'){
  //   _url = `${UrlName}/getConfigByBranch`;
  // } else {
    _url = `${UrlName}/configurations/${confUrl}`;
  // }
  API({
    url: _url,
    method: 'Get',
    header: {
      'channel': 1
    }
  })
    .then((data) => {
      let frontendConfig = data.data.frontendConfig
      // frontendConfig.map(item=>{
      //   if(item.key === 'theme'){
      //     // setTheme(item.value);
      //   }
      // })
      _this.commit('storePageEndSetting', data.data.pageEndSetting);
      _this.commit('storePageEnd', data.data.pageEnd);
      _this.commit('setPageSetData', data.data);
      _this.commit('storePageHeader',data.data.pageHeader);
      _this.commit('storePageHeaderSetting',data.data.pageHeaderSetting);
      _this.commit('pageBackgroundSetting', JSON.stringify(data.data.pageBackgroundSetting))
      _this.commit('frontendConfig', data.data.frontendConfig);
      //兼容版本写入localStorage start
        frontendConfig = data.data.frontendConfig.filter(item => {
          if (item.key === 'homepage') {
            return true;
          }
        })[0];
        localStorage.setItem('domain', JSON.stringify(data.data.solutionInfo.domain)?JSON.stringify(data.data.solutionInfo.domain):'');
        localStorage.setItem('theme', data.data.theme || '');
        localStorage.setItem('frontendConfig', frontendConfig ? JSON.stringify(frontendConfig) : '');
        localStorage.setItem('hasGetConfig', '1')
        localStorage.setItem('configurationArr', JSON.stringify(data.data.frontendConfig))
        localStorage.setItem('setTempConfigs', JSON.stringify(data.data))
        localStorage.setItem('branchId', data.data.branchId)
        localStorage.setItem('saasId', data.data.solutionInfo.rid)
        if (data.data.pageLogo) {
          let link = document.querySelector("link[rel*='icon']");
          link.href = data.data.pageLogo;
          localStorage.setItem('pageLogo', data.data.pageLogo);
        }
        if (data.data.pageTitle) {
          document.title = data.data.pageTitle;
          localStorage.setItem('pageTitle', data.data.pageTitle)
        }
        router.beforeEach((to, from, next) => {
          if(data.data.solutionInfo.domain){
            let _href = data.data.solutionInfo.domain.filter( item=> item.frontend_template_id === 4) //配置的路由
            let _hrefDomain =  _href[0].domain
            let isHomepage = data.data.frontendConfig.filter((item)=>{ return item.key ==='homepage'})[0].value; //首页路由
            let isAutoRedirect = JSON.parse(data.data.frontendConfig.filter((item)=>{ return item.key ==='is_auto_redirect'})[0].value); //是否需要pc跳转显示H5
            if(to.path.split('/')[1] == isHomepage && IsMobile() && isAutoRedirect){
              window.location.href = `https://${_hrefDomain}`
            } else {
              next();
            }
          } else {
              next();
          }
         })
      //兼容版本写入localStorage end

    })
    .catch((error) => {
      // setTheme('init');
      if(!sessionStorage.getItem("nomessage")){
        message('error');
       }
      console.log("error---", error);
    });

}

function getLayoutJson(router, _this, resolve, reject) {
  let base = require('js-base64').Base64;
  const port = window.location.port;
  const hostname = window.location.hostname
  const UrlName = '/modular/admin/v1'
  let confUrl = port ? base.encode(URL.TestDomain) : base.encode(hostname);
  let search = window.location.search;
  let type = search.includes('preview')?'1':'';
  let apiUrl
  // if(isB === 'isB'){
  //   apiUrl = type != '1'?`${UrlName}/getPagesByBranch`:`${UrlName}/getPagesByBranch?type=1`;
  // } else {
    apiUrl = type != '1'?`${UrlName}/pages/${confUrl}`:`${UrlName}/pages/${confUrl}?type=1`;
  // }
  API({
    url:apiUrl,
    method: 'Get',
  }).then(async(data) => {
      if (data.code == "0") {
        // localStorage.setItem('setPageConfigs', JSON.stringify(data.data.dragList)) //本地存储数据
        let newData = unzip(data.data);
         await newData.pages.map((page) => {
            if (page.uri) {
              const route = {
                path: page.uri.indexOf(':') != -1 ? page.uri.split(':')[0] : page.uri,
                name: page.pageName,
                query: page.uri.indexOf(':') != -1 ? page.uri.split(':')[1] : '',
                component: () => import(/* webpackChunkName: 'common' */ '../plugin/view/common/index.vue'),
                meta: {
                  keepAlive: true,
                  moduleId: page.pageName,
                  name: page.label,
                  noLogin: true
                },
              };
              router.addRoute(route);
            }

            if (page.manual_url) {
              const routes = {
                path: page.manual_url,
                name: page.pageName,
                query: '',
                component: () => import(/* webpackChunkName: 'common' */ '../plugin/view/common/index.vue'),
                meta: {
                  keepAlive: true,
                  moduleId: page.pageName,
                  name: page.label,
                  noLogin: true
                },
              };
              router.addRoute(routes);
            }
          });
        await _this.commit('setPageConfigs', newData.pages);
        resolve(router);
      } else {
        reject(data.message);
      }
    })
    .catch((error) => {
      console.log("error---", error);
    });
}

let setLayoutToRouter = (router, _this) => {
  return new Promise((resolve, reject) => {
    // if(isB === 'isB'){
    //   getLayoutSetting(router, _this,isB)
    //   getLayoutJson(router, _this, resolve, reject,isB)
    // } else {
      getLayoutSetting(router, _this)
      getLayoutJson(router, _this, resolve, reject)
    // }
  }).then((e) => {
    addErrorRouter(e)
    sessionStorage.setItem('setLayoutToRouter',true);
    addRouter(router)
  }).catch((error) => {
    console.log('error--->', error)
  })
}
let getSetPageConfigs = (_this) => {
  return _this.state.dynamic.pageConfigs;
}
let getPageEndSetting = (_this) => {
  return _this.state.dynamic.pageEndSetting;
}
let getPageEnd = (_this) => {
  return _this.state.dynamic.pageEnd;
}
let getPageBackgroundSetting = (_this) => {
  return _this.state.dynamic.pageBackgroundSetting;
}
//获取除页面外所有数据
let getConfigruation = (_this) => {
  return _this.state.dynamic.pageSetData;
}

export default {
  setLayoutToRouter,
  getSetPageConfigs,
  getPageEndSetting,
  getPageEnd,
  getConfigruation,
  getPageBackgroundSetting
}
